import { render, staticRenderFns } from "./BasePropTabGeneral.vue?vue&type=template&id=447a8c8e&scoped=true&"
import script from "./BasePropTabGeneral.vue?vue&type=script&lang=js&"
export * from "./BasePropTabGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447a8c8e",
  null
  
)

export default component.exports